module.exports = __webpack_public_path__ + "img/delete_icon.3bd39fd9.svg";